import { render } from "./ProfilesTable.vue?vue&type=template&id=3483cb05&scoped=true"
import script from "./ProfilesTable.vue?vue&type=script&lang=js"
export * from "./ProfilesTable.vue?vue&type=script&lang=js"

import "./ProfilesTable.vue?vue&type=style&index=0&id=3483cb05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3483cb05"]])

export default __exports__